import { globalThemeManager } from 'foundations-theming/utils';
export const setMobileTheme = () => {
  const query = new URLSearchParams(window.location.search);
  const isMobileLogin = query.get('reauth');
  if (isMobileLogin) {
    // ensures theme matches Breeze app design if we are in a mobile login
    globalThemeManager.setTheme({
      themeName: 'trellis',
      themeMode: 'light'
    });
  }
};